module.exports = __webpack_public_path__ + "img/close-dialog.a47e0dda.svg";